Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'market_stats',
  '.sc-market-stats',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {
  // Widget Declarations
  const $this = $(el);
  const formatMoney = value => formatLabels(value, {prefix: '$'});
  const formatPercent = value => formatLabels(value, {suffix: '%'});
  // gradient colors
  const blueLight = 'rgba(31,119,180,0.2)';
  const blueLighter = 'rgba(31,119,180,0.05)';
  const blueTransparent = 'rgba(31,119,180,0)';
  const redLight = 'rgba(217,34,40,0.25)';
  const redLighter = 'rgba(217,34,40,0.05)';
  const redTransparent = 'rgba(217,34,40,0)';
  const baseConfiguration = {
    xAxis: {
      nameLocation: 'middle',
      nameGap: 110,
      nameTextStyle: {color: '#000000'},
      type: 'category',
      axisTick: {show: false},
      axisLabel: {color: '#000000'},
    },
    yAxis: {
      nameLocation: 'middle',
      nameTextStyle: {color: '#000000'},
      type: 'value',
      axisLine: {show: false},
      splitLine: {lineStyle: {color: '#cccccc', width: 2}},
      axisLabel: {
        color: '#000000',
        formatter: formatLabels,
      },
    },
    grid: {
      left: 40,
      containLabel: true
    },
    tooltip: {
      trigger: 'axis',
      valueFormatter: formatLabels,
      textStyle: {
        fontSize: 12
      },
      className: `${className}__tooltip`,
    },
  };
  const configurationByType = {
    line: {
      xAxis: {axisLabel: {interval: 5, rotate: 0}},
      yAxis: {position: 'right', splitLine: {show: false}},
      series: {
        type: 'line',
        showSymbol: false,
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {offset: 0, color: blueLight},
              {offset: 0.6, color: blueLighter},
              {offset: 1, color: blueTransparent},
            ],
          },
        },
      },
      grid: {
        top: 30,
        bottom: 30,
        left: 20,
        right: 15,
      },
    },
    bar: {
      xAxis: {
        axisLabel: {
          interval: 0,
          rotate: 45,
          formatter: truncate,
        }
      },
      yAxis: {position: 'left'},
      series: {
        type: 'bar',
        itemStyle: {color: '#d92228', width: 2},
        barGap: '1%',
        barMaxWidth: 50,
        axisLine: {color: '#cccccc', width: 2},
      },
      grid: {
        left: 60,
      },
    }
  };
  const configurationByMetric = {
    'for-sale-price-median': {
      chartType: 'bar',
      yAxis: {
        name: 'Median listing home price',
        nameGap: 50,
        axisLabel: {
          formatter: formatMoney,
        },
      },
      tooltip: {
        valueFormatter: formatMoney,
      },
    },
    'for-rent-price-median': {
      chartType: 'bar',
      yAxis: {
        name: 'Median monthly rental price',
        nameGap: 50,
        axisLabel: {
          formatter: formatMoney,
        },
      },
      tooltip: {
        valueFormatter: formatMoney,
      },
    },
    'for-sale-count': {
      chartType: 'bar',
      yAxis: {
        name: 'For sale',
        nameGap: 50
      },
    },
    'for-rent-count': {
      chartType: 'bar',
      yAxis: {
        name: 'For rent',
        nameGap: 50
      }
    },
    'for-sale-days-on-market-median': {
      chartType: 'bar',
      yAxis: {
        name: 'Median days on market',
        nameGap: 40
      }
    },
    'mom-for-sale-days-on-market-median': {
      chartType: 'bar',
      yAxis: {
        name: 'Median days on market % MoM',
        nameGap: 40
      },
      tooltip: {
        valueFormatter: formatPercent,
      },
    },
    'historical-price': {
      chartType: 'line',
      yAxis: {
        axisLabel: {
          formatter: formatMoney,
        },
      },
      legend: {
        bottom: 0,
        orient: 'horizontal',
        textStyle: {
          color: '#000000',
          fontSize: 12
        },
        itemWidth: 40,
        itemHeight: 4
      },
      tooltip: {
        valueFormatter: formatMoney,
      },
    },
    'historical-days-on-market': {
      chartType: 'line',
    }
  };
  const configurationBySeries = {
    listing_price_median_values: {
      name: 'Median listing home price',
      itemStyle: {color: '#d92228'},
      areaStyle: {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {offset: 0, color: redLight},
            {offset: 0.6, color: redLighter},
            {offset: 1, color: redTransparent},
          ],
        },
      },
    },
    sale_price_median_values: {
      name: 'Median home sold price',
      itemStyle: {color: '#1e61d9'},
      lineStyle: {type: 'dashed'},
    },
    days_on_market_median_values: {
      name: 'Median days on market',
    },
    for_sale_price_median_values: {
      name: 'Median listing home price',
    },
    for_rent_price_median_values: {
      name: 'Median monthly rental price',
    },
    for_sale_count_values: {
      name: 'For sale',
    },
    for_rent_count_values: {
      name: 'For rent',
    },
    for_sale_days_on_market_median_values: {
      name: 'Median days on market',
    },
    mom_for_sale_days_on_market_median_values: {
      name: 'Median days on market % MoM',
    }
  };

  /**
   * Initialize the widget
   */
  (function init(){
    render();
    addEvents();
  })();

  /**
   * Handle UI events
   */
  function addEvents() {
    $this.on('shown.bs.tab', render);
    $.breakpoint('change', render);
  }


  /**
   * Render the charts
   */
  function render() {
    const $charts = $this.find(`${selector}__chart:visible`);
    $charts.each(renderChart);
  }


  /**
   * Render each chart using the corresponding data.
   */
  function renderChart(index, $chart) {
    // Do not initialize the same chart more than once, simply resize
    if ($chart.getAttribute('shown')) {
      echarts.getInstanceByDom($chart).resize();
      return;
    }

    const metric = $($chart).attr('data-metric');
    const region = $($chart).attr('data-region');

    const data = JSON.parse(model.chartsData.find(item => item.chart_type === metric && item.related_region_level === region).json);
    const formattedSeries = [];

    // get metric-specific configuration
    const metricConfiguration = configurationByMetric[metric];

    // get type-specific configurations
    const typeConfiguration = configurationByType[metricConfiguration.chartType];

    $.each(data.series, function (key, value) {
      // get type-specific series render configurations
      const seriesBase = typeConfiguration.series || {};

      // get series-specific render configurations
      const seriesSpecific = configurationBySeries[key] || {};

      const seriesConfig = {
        ...seriesBase,
        ...seriesSpecific,
        data: value.data,
      };
      if (value.data.length === 1) {
        seriesConfig.showSymbol = true;
      }
      formattedSeries.push(seriesConfig);
    });

    const chart = echarts.init($chart);
    chart.setOption($.extend(
      true,
      // start from a clean object to avoid mutating shared configurations
      // merge from general to specific data/configurations
      {},
      baseConfiguration,
      typeConfiguration,
      metricConfiguration,
      {xAxis: {name: $($chart).attr('data-level')}},
      data,
      {series: formattedSeries},
    ));
    $chart.setAttribute('shown', true);
  }


  /**
   * Shortens numeric values. Converts thousands to the k suffix and millions to the m suffix.
   *
   * @param string value
   * @param object options
   * @returns
   */
  function formatLabels(value, options = {}) {
    const prefix = options?.prefix || '';
    const suffix = options?.suffix || '';

    if (value === 0) {
      return value;
    }

    if (!value) {
      return 'N/A';
    }

    const formattedValue = value.toLocaleString(undefined, {
      notation: 'compact',
      compactDisplay: 'short',
      maximumFractionDigits: 1
    });
    return `${prefix}${formattedValue}${suffix}`;
  }

  /**
   * Truncates a string to 20 characters and adds ellipsis.
   *
   * @param string value
   * @returns string
   */
  function truncate(value) {
    if (value.length <= 20) {
      return value;
    }

    return value.substring(0, 20) + '...';
  }
});
